var Backbone, FAQSearchModel,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

FAQSearchModel = (function(superClass) {
  extend(FAQSearchModel, superClass);

  function FAQSearchModel() {
    return FAQSearchModel.__super__.constructor.apply(this, arguments);
  }

  FAQSearchModel.prototype.initialize = function() {
    return this.baseUrl = window.FAQBASEURL + "/search";
  };

  FAQSearchModel.prototype.setUrl = function(searchText) {
    searchText = encodeURIComponent(searchText);
    return this.url = this.baseUrl + "?should_display_cms_content=" + experiments.shouldDisplayCMSContentForUS + "&search_text=" + searchText;
  };

  return FAQSearchModel;

})(Backbone.Model);

module.exports = FAQSearchModel;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUva3VtYXJyYS9uYXBpc3RyYW5vL2J1aWxkLzE1MDQ3NzgxNDM1MjYtNzYxNzcvcHJvZHVjdGlvbi0yMDE3LjA5LjA3XzA5LjU0L3N1cHBvcnRfYXBwL21vZHVsZXMvZmFxL2Zyb250ZW5kL21vZGVscy9zZWFyY2guY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUva3VtYXJyYS9uYXBpc3RyYW5vL2J1aWxkLzE1MDQ3NzgxNDM1MjYtNzYxNzcvcHJvZHVjdGlvbi0yMDE3LjA5LjA3XzA5LjU0L3N1cHBvcnRfYXBwL21vZHVsZXMvZmFxL2Zyb250ZW5kL21vZGVscy9zZWFyY2guY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUEsd0JBQUE7RUFBQTs7O0FBQUEsUUFBQSxHQUFXLE9BQUEsQ0FBUSxVQUFSOztBQUVMOzs7Ozs7OzJCQUNKLFVBQUEsR0FBWSxTQUFBO1dBQ1YsSUFBQyxDQUFBLE9BQUQsR0FBYyxNQUFNLENBQUMsVUFBUixHQUFtQjtFQUR0Qjs7MkJBR1osTUFBQSxHQUFTLFNBQUMsVUFBRDtJQUNQLFVBQUEsR0FBYSxrQkFBQSxDQUFtQixVQUFuQjtXQUNiLElBQUMsQ0FBQSxHQUFELEdBQVUsSUFBQyxDQUFBLE9BQUYsR0FBVSw4QkFBVixHQUF3QyxXQUFXLENBQUMsNEJBQXBELEdBQWlGLGVBQWpGLEdBQWdHO0VBRmxHOzs7O0dBSmtCLFFBQVEsQ0FBQzs7QUFRdEMsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
